import { unitDefault } from "@/settings/unitTypes";
export const CompCent = {
  id: "5",
  name: "Compresor",
  mainClass: "Rotativos",
  subtype: "Centrífugo",
  variables: [
    //   New variables:[FET] - Incluir nuevos parámetros/variables (Petropiar)
    {
      type: "steps",
      unit: "",
      code: "equipmentOperationMode",
      groups: "steps",
      values: [
        { name: "Manual", value: 0, alarm: false },
        { name: "Automatic", value: 1, alarm: true }
      ],
      min: 0,
      max: 1
    },
    {
      type: "steps",
      unit: "",
      code: "ventValveMode",
      groups: "steps",
      values: [
        { name: "Manual", value: 0, alarm: false },
        { name: "Automatic", value: 1, alarm: true }
      ],
      min: 0,
      max: 1
    },
    {
      type: "steps",
      unit: "",
      code: "airInletValveMode",
      groups: "steps",
      values: [
        { name: "Manual", value: 0, alarm: false },
        { name: "Automatic", value: 1, alarm: true }
      ],
      min: 0,
      max: 1
    },
    {
      values: [60, 65, 80, 90],
      min: 0,
      max: 100,
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "general",
      code: "ventingValve"
    },
    {
      values: [60, 65, 80, 90],
      min: 0,
      max: 100,
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "general",
      code: "airInletValve"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "highVaporPressure"
    },

    /*    // Example 4 Values Steps
    {
      type: "steps",
      unit: "",
      code: "example4Values",
      groups: "steps",
      values: [
        { name: "Bajo bajo", value: 1, alarm: false },
        { name: "Bajo", value: 2, alarm: false },
        { name: "Alto", value: 3, alarm: false },
        { name: "Alto alto", value: 4, alarm: true }
      ],
      min: 0,
      max: 1
    }, */
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor1StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor2StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor3StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor4StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor5StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor6StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor7StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor8StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor9StagePressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressor10StagePressure"
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor1StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor2StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor3StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor4StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor5StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor6StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor7StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor8StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor9StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressor10StageTemp",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressorPressureDifference"
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressorTemperatureIn",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "compressorDewPoint",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      values: [60, 65, 80, 90],
      min: 0,
      max: 100,
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "general",
      code: "compressorOilLevel"
    },
    {
      values: [60, 65, 80, 90],
      min: 0,
      max: 100,
      type: "outputFlow",
      unit: unitDefault.outputFlow.metric,
      groups: "general",
      code: "compressorOutflow"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressorPressIn"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressorPressOut"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressorPlantAirPressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "compressorOilPressure"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "vibration",
      unit: unitDefault.vibration.metric,
      groups: "general",
      code: "compressorLowPinionVibration"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "vibration",
      unit: unitDefault.vibration.metric,
      groups: "general",
      code: "compressorHighPinionVibration"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "angularSpeed",
      unit: unitDefault.angularSpeed.metric,
      groups: "general",
      code: "compressorSpeed"
    },
    {
      values: [150, 200, 240, 250],
      min: 0,
      max: 300,
      type: "electricCurrent",
      unit: unitDefault.electricCurrent.metric,
      groups: "general",
      code: "compressorElectricityConsumption"
    },
    {
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000,
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "general",
      code: "compressorCoolingWater"
    }
  ],
  operationalValues: [
    {
      value: 0,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "compressorPressIn"
    },
    {
      value: 0,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "compressorPressOut"
    },
    {
      value: 0,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "compressorPressureDifference1"
    },
    {
      value: 2,
      type: "unique",
      unit: "Stages",
      code: "compressorNumberOfStages"
    },
    {
      value: "Motor",
      type: "unique",
      unit: "",
      code: "compressorDriver"
    },
    {
      value: 0,
      type: "angularSpeed",
      unit: unitDefault.angularSpeed.metric,
      code: "compressorMaxSpeed"
    }
  ]
};
